import palette from "~/assets/scss/_palette.module.scss";
import allColors from "~/assets/scss/_color.module.scss";

export const colors = {
  ...palette,
  ...allColors,
};
